import { useMemo } from "react";
import Select, { MultiValue, StylesConfig } from "react-select";
import styled from "styled-components";
import { useReactSelectTheme } from "@bagel-web/components";

type FunctionOption = {
  value: string;
  label: string;
};

export type FunctionSelectProps = {
  value?: string | null;
  onChange?: (e: { target: { value: Array<string> } }) => void;
  autoFocus?: boolean;
  functionNames: Array<string>;
};

const SelectContainer = styled.div`
  width: 400px;
`;

const styleOverrides: StylesConfig<FunctionOption> = {
  container: (baseStyles) => ({
    ...baseStyles,
    minWidth: "300px",
  }),
  option: (baseStyles, { isSelected }) => ({
    ...baseStyles,
    fontFamily: "monospace",
    fontSize: ".875em",
    color: isSelected ? "white" : "var(--bs-code-color)",
  }),
  singleValue: (baseStyles) => ({
    ...baseStyles,
    fontFamily: "monospace",
    fontSize: ".875em",
    color: "var(--bs-code-color)",
  }),
  multiValueLabel: (baseStyles) => ({
    ...baseStyles,
    fontFamily: "monospace",
    fontSize: ".875em",
    color: "var(--bs-code-color)",
  }),
};

const FunctionSelect = ({
  functionNames,
  onChange,
  autoFocus,
}: FunctionSelectProps) => {
  const options = useMemo(() => {
    return functionNames.map((functionName) => ({
      value: functionName,
      label: functionName,
    }));
  }, [functionNames]);

  return (
    <SelectContainer>
      <Select
        isMulti={true}
        styles={styleOverrides}
        theme={useReactSelectTheme()}
        placeholder="Filter functions..."
        options={options}
        autoFocus={autoFocus}
        menuPortalTarget={document.body}
        onChange={(value: MultiValue<FunctionOption>) => {
          onChange?.({
            target: { value: value.map((v) => v.value) },
          });
        }}
      />
    </SelectContainer>
  );
};

export default FunctionSelect;
